import React from 'react'

const ChevronRightIcon = props => (
  <svg width={24} height={24} style={{borderRadius: 12, transform: "scale(0.8) rotateY(180deg)"}} {...props}>
    <path fill={"rgb(149,193,31)"} fillOpacity={props.disabled ? 0.5 : 1} d="M0 0h24v24H0V0z" />
    <path fill="white" d="M9.29 6.71a.996.996 0 0 0 0 1.41L13.17 12l-3.88 3.88a.996.996 0 1 0 1.41 1.41l4.59-4.59a.996.996 0 0 0 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z" />
  </svg>
)

export default ChevronRightIcon



// WEBPACK FOOTER //
// ./src/components/ChevronLeftIcon.js